<template>
    <div class="journey-list">
        <div v-if="children.length > 0" class="children">
            <draggable
                :value="value.children"
                :options="{ group: 'children', handle: '.handle' }"
                @input="moved"
            >
                <div
                    v-for="(child, id) in value.children"
                    :class="'child ' + child.state"
                    :key="id"
                >
                    <div class="drag-handler handle"></div>
                    <div class="child-pieces">
                        <strong>
                            <input
                                type="text"
                                :value="child.name"
                                @blur="rename(id, $event)"
                                @keyup.enter="rename(id, $event)"
                                @keyup.esc="
                                    () => {
                                        $event.target.value = child.name;
                                        $event.target.blur();
                                    }
                                "
                            />
                        </strong>
                        <div>
                            <button class="btn-remove">
                                <span class="far-icon fa fa-close"></span>
                            </button>
                            <router-link
                                :to="'/settings/journey/' + child.id"
                                class="btn btn-sm btn-outline-dark"
                            >
                                <span class="far-icon fa fa-indent"></span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </draggable>
        </div>
        <div>
            <input
                type="text"
                @keyup.enter="addNew($event)"
                class="form-control"
                :placeholder="t('settings-journey-add_stage_placeholder')"
            />
        </div>
    </div>
</template>
<style lang="scss" scoped>
.journey-list {
    width: 100%;
}
.children {
    display: block;
    width: 100%;
    margin: 20px 0;
}
.child {
    position: relative;
    padding: 10px 10px 10px 20px;
    margin: 10px 0;
    display: block;
    width: 100%;
    background: #fff;
    &.loading {
        background: #f555;
    }
    .btn-remove {
        position: absolute;
        top: -10px;
        right: -10px;
        background: transparent;
        border-radius: 50%;
        font-size: 12px;
        border: none;
        transition: all 0.3s;
        &:hover {
            color: #f00;
        }
    }
    .child-pieces {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .drag-handler {
        &:before {
            width: 30px;
        }
    }
    input {
        border: none;
    }
}
</style>
<script>
import keviApi from "../../keviApi";
import draggable from "vuedraggable";

export default {
    name: "journey-list",
    props: {
        value: Object,
        parentId: String,
        variant: String,
    },
    components: {
        draggable,
    },
    computed: {
        children() {
            return this.value.children || [];
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        addNew(event) {
            const position = this.value.children.length;
            const params = {
                name: event.target.value,
                position,
                variant: this.variant ? this.variant : this.t('settings-journey-board_prefix'),
            };
            if (this.parentId) {
                params.parent_clients_stages_id = this.parentId;
            }
            const options = keviApi.getOptions("client-stage", "POST", params);
            this.$http(options).then(
                (response) => {
                    const newItem = {
                        ...response.data,
                        children: [],
                    };
                    this.$emit("input", {
                        ...this.value,
                        children: [...(this.value.children || []), newItem],
                    });
                },
                (error) => {
                    this.$store.dispatch("notification/error", error);
                },
            );
            event.target.value = "";
        },
        moved(event) {
            const newValue = { ...this.value, children: [...event] };
            this.$emit("input", newValue);
            const params = {
                positions: event.map((item, idx) => {
                    return {
                        id: item.id,
                        position: idx,
                    };
                }),
            };
            const options = keviApi.getOptions(
                "client-stage/positions",
                "POST",
                params,
            );
            this.$http(options).then(
                (response) => {
                    this.$store.dispatch("notification/success", this.t('settings-journey-order_saved'));
                },
                (error) => {
                    this.$store.dispatch("notification/error", error);
                },
            );
        },
        rename(idx, event) {
            const oldName = this.value.children[idx].name;
            if (oldName === event.target.value) {
                return;
            }
            const newValue = { ...this.value };
            newValue.children[idx].name = event.target.value;
            const options = keviApi.getOptions("client-stage", "POST", {
                id: newValue.children[idx].id,
                name: event.target.value,
            });
            this.$http(options).then(
                () => {
                    this.$store.dispatch(
                        "notification/success",
                        this.t('settings-journey-stage_renamed'),
                    );
                },
                (error) => {
                    this.$store.dispatch("notification/error", error);
                },
            );
            this.$emit("input", newValue);
        },
    },
};
</script>
